/**
 * Generated bundle index. Do not edit.
 */

export {InternationalPhoneModule,Country,CountryCode,CountryLocale,CountryPipe,OnlyNumberDirective,CountryService,LocaleService,IntPhonePrefixComponent} from './index';
